import * as React from 'react'
import SettingsIcon from '@mui/icons-material/Settings'
import Button from '@mui/material/Button'
import DialogContent from '@mui/material/DialogContent'
import { BootstrapDialog, BootstrapDialogTitle } from 'common/AbstractModal/BootstrapDialog'

import { ChangeCatalogPriceForm } from './ChangeCatalogPriceForm'
export interface ChangeCatalogPriceDialogProps {
  id: string
}

export default function ChangeCatalogPriceDialog({
  id
}: ChangeCatalogPriceDialogProps) {
  const [open, setOpen] = React.useState(false)
  const handleClickOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  //handle form submit api here
  return (
    <div>
      <Button variant='contained' onClick={handleClickOpen}>
        <SettingsIcon />
      </Button>
      <BootstrapDialog
        fullWidth
        maxWidth='lg'
        onClose={handleClose}
        aria-labelledby='customized-dialog-title'
        open={open}
      >
        <BootstrapDialogTitle onClose={handleClose}>
          Change catalog price
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <ChangeCatalogPriceForm catalogId={id} handleClose={handleClose} />
        </DialogContent>
      </BootstrapDialog>
    </div>
  )
}
